import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { BodyLong01, ProductiveHeading06 } from 'components/styles';
import { useQueryIdps } from 'queries/saml';
import { LoginPolicy } from './login-policty';
import { SSOList } from './sso-list';

const SetupWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SetupHeader = styled.p`
  ${ProductiveHeading06};
  margin-bottom: var(--spacing-02);
`;

const SetupBody = styled.p`
  ${BodyLong01};
  margin-bottom: 0;
  color: var(--gray-70);
`;

const Divider = styled.div`
  border: 1px solid var(--gray-10);
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
  border: 1px solid var(--gray-10);
  padding: var(--spacing-05) var(--spacing-06);
`;

export const SetupSaml: FC = () => {
  const { data: idps } = useQueryIdps();
  const showLoginPolicy = idps?.find((item) => item.enabled);

  return (
    <Wrapper>
      <SetupWrapper>
        <div>
          <SetupHeader>
            <FormattedMessage id="settings.security.saml.title" />
          </SetupHeader>
          <SetupBody>
            <FormattedMessage id="settings.security.saml.body" />
          </SetupBody>
        </div>
      </SetupWrapper>
      <>
        <Divider />
        <SSOList />
        {showLoginPolicy && (
          <>
            <Divider />
            <LoginPolicy />
          </>
        )}
      </>
    </Wrapper>
  );
};
